<template>
    <div class="mobile-top-bar-main">
        <div class="mobile-top-bar">
            <mobile-topbar @show-menu="onShowMenu"></mobile-topbar>
            <transition name="slide-fade">
                <div v-if="show" class="sidebar-mobile">
                    <sidebar-list class="sidebar-mobile__list"></sidebar-list>
                    <sidebar-social-networks
                        class="sidebar-mobile__networks"
                    ></sidebar-social-networks>
                    <sidebar-user-agreement
                        class="sidebar-mobile__agreement"
                    ></sidebar-user-agreement>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import MobileTopbar from '@/components/sidebar_mobile/sections/MobileTopbar';
import SidebarList from '@/components/sidebar/sections/SidebarList';
import SidebarSocialNetworks from '@/components/sidebar/sections/SidebarSocialNetworks';
import SidebarUserAgreement from '@/components/sidebar/sections/SidebarUserAgreement';

export default {
    name: 'Index',
    components: {
        MobileTopbar,
        SidebarList,
        SidebarSocialNetworks,
        SidebarUserAgreement,
    },
    data() {
        return {
            show: false,
        };
    },
    methods: {
        onShowMenu() {
            this.show = !this.show;
        },
    },
};
</script>

<style scoped lang="scss">
.mobile-top-bar-main {
    position: -webkit-sticky;
    position: sticky;
    top: 74px;
    z-index: 20;
    @media (min-width: $sm-up) and (max-width: $lg-up) {
        top: 67px;
    }
    @media (min-width: $xs-up) and (max-width: $sm-up) {
        top: 57px;
    }
    @media (min-width: $xxs-up) and (max-width: $xs-up) {
        top: 48px;
    }
}
.mobile-top-bar {
    width: auto;
    height: 90px;
    background-color: #dce3e9;
    position: -webkit-sticky;
    position: sticky;
    top: 56px;
    z-index: 20;
    @media (min-width: 1201px) {
        display: none;
    }
    @media (min-width: $xs-up) and (max-width: $lg-up) {
        height: 78px;
    }
    @media (min-width: $xxs-up) and (max-width: $xs-up) {
        height: 52px;
    }
}
.sidebar-mobile {
    display: grid;
    grid-auto-rows: 26rem 10rem 10rem;
    width: auto;
    height: auto;
    background-color: #dce3e9;
    @media (max-width: $sm-up) {
        grid-auto-rows: 26rem 9rem 9rem;
    }
    &__list {
        grid-row: 1;
    }
    &__networks {
        grid-row: 2;
    }
    &__agreement {
        grid-row: 3;
    }
}
</style>
